import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { Props } from '../../../shared/assets/SvgProps';

const AwaitingPartsIcon = ({
  color = '#3F3F3F'
}: Props) => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <Path
      d="M10.6641 21.73C10.9681 21.9056 11.313 21.998 11.6641 21.998C12.0151 21.998 12.36 21.9056 12.6641 21.73L19.6641 17.73C19.9678 17.5547 20.2201 17.3025 20.3956 16.9989C20.5711 16.6952 20.6637 16.3508 20.6641 16V8.00002C20.6637 7.6493 20.5711 7.30483 20.3956 7.00119C20.2201 6.69754 19.9678 6.44539 19.6641 6.27002L12.6641 2.27002C12.36 2.09449 12.0151 2.00208 11.6641 2.00208C11.313 2.00208 10.9681 2.09449 10.6641 2.27002L3.66406 6.27002C3.36033 6.44539 3.10804 6.69754 2.93252 7.00119C2.75701 7.30483 2.66442 7.6493 2.66406 8.00002V16C2.66442 16.3508 2.75701 16.6952 2.93252 16.9989C3.10804 17.3025 3.36033 17.5547 3.66406 17.73L10.6641 21.73Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M11.6641 22V12"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M2.95312 7L11.6631 12L20.3731 7"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M7.16406 4.26953L16.1641 9.41953"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default AwaitingPartsIcon;
